import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';

import { Subscription } from 'rxjs';
import { ServicecallService } from 'src/app/services/servicecall.service';

@Component({
  selector: 'app-chat-bot',
  templateUrl: './chat-bot.component.html',
  styleUrls: ['./chat-bot.component.css']
})
export class ChatBotComponent implements OnInit, OnDestroy {
  @ViewChild('scroll', { read: ElementRef }) public scroll: ElementRef<any>;
  @Output() botAction = new EventEmitter<any>();

  masterChatList: any[] = [];
  msg = new FormControl('');
  isLoader: boolean = false;
  chatCurrentResponse: any;
  roleName: string;

  private _chatGptGetMsgSubscription: Subscription;
  private _botProceedSubscription: Subscription;
  private _roleListSubscription: Subscription;

  constructor(private _sharedService: ServicecallService) { }

  ngOnInit(): void {
    this._getRole();
  }

  ngOnDestroy(): void {
    this._chatGptGetMsgSubscription?.unsubscribe();
    this._botProceedSubscription?.unsubscribe();
    this._roleListSubscription?.unsubscribe();
  }

  /**
   * Submits input
   * @returns  
   */
  submitInput() {
    if (!this.msg.value) {
      return;
    }
    this.scroll.nativeElement.scrollTop = this.scroll.nativeElement.scrollHeight;
    this.isLoader = true;
    this.masterChatList.push({
      key: 'outgoing',
      msg: this.msg.value
    });
    const botPayload = this.msg?.value;
    this._chatGptGetMsgSubscription = this._sharedService.getChatResponse(botPayload).subscribe({
      next: (res: any) => {
        this.chatCurrentResponse = res;
        if (res?.isJsonForm) {
          this.masterChatList.push({
            key: 'incoming',
            msg: {
              details: res?.details,
              url: res?.url,
              method: res?.method
            },
            type: 'json',
          });
        } else {
          this.masterChatList.push({
            key: 'incoming',
            msg: res?.details
          });
        }
        this.scroll.nativeElement.scrollTop = this.scroll.nativeElement.scrollHeight;
        this.isLoader = false;
      },
      error: (error: any) => {
        this.masterChatList.push({
          key: 'incoming',
          msg: error
        });
        this.isLoader = false;
      }
    });
    this.msg.reset();
    if (this.masterChatList.length > 40) {
      this.masterChatList.splice(0, 11);
    }
  }

  /**
   * Bots close
   * @param type 
   */
  botClose(type: any) {
    if (type === 'close') {
      this.botAction.emit({ type: 'close', value: false });
      this.masterChatList = [];
    }
  }

  /**
   * Bots user action
   * @param actionType 
   */
  botUserAction(actionType: string) {
    if (actionType === 'reenter') {
      this.msg.setValue(this.chatCurrentResponse?.data?.prevPrompt);
    } else if (actionType === 'proceed') {
      this.isLoader = true;
      this._botProceedSubscription = this._sharedService.botProceed(this.chatCurrentResponse).subscribe({
        next: (response: any) => {
          this.isLoader = false;
          this.masterChatList.push({
            key: 'incoming',
            msg: response,
            type: 'json'
          });
        },
        error: (error: any) => {
          this.masterChatList.push({
            key: 'incoming',
            msg: error
          });
          this.isLoader = false;
        }
      });
    }
    this.chatCurrentResponse = null;
  }

  /**
   * Gets role
   */
  private _getRole() {
    if (!sessionStorage.getItem('roleName')) {
      this._roleListSubscription = this._sharedService.roleList().subscribe((result: any) => {
        if (result["status"] && result?.["response"]?.['data']?.length) {
          this.roleName = result?.["response"]?.['data'].find((elem: any) => elem?._id === localStorage.getItem('roleId'))?.roleName;
          sessionStorage.setItem('roleName', this.roleName);
        }
      });
    }
    else {
      this.roleName = sessionStorage.getItem('roleName')
    }
  }
}
